const faqs = [
  {
    question: "This is a question",
    answer: "Answer goes here",
  },
]

export { faqs }
